"use strict";
export class LocalStorage {
  constructor(namespace) {
    this._namespace = namespace;
  }
  delete(key) {
    return localStorage.removeItem(`${this._namespace}:${key}`);
  }
  get(key) {
    return JSON.parse(localStorage.getItem(`${this._namespace}:${key}`));
  }
  has(key) {
    const _item = localStorage.getItem(`${this._namespace}:${key}`);
    if (_item) {
      return true;
    }
    return false;
  }
  set(key, value) {
    localStorage.setItem(`${this._namespace}:${key}`, JSON.stringify(value));
    return this;
  }
}
